// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NinFL","content":"styles_content__SvQif","row":"styles_row__V_PCK","footer":"styles_footer__3CYcC","phraseLength":"styles_phraseLength__2ZmMg"};